<template>
    <b-button variant="primary" @click.stop="confirmar()" v-if="mostrarBtn">
        <span> <i class="fa fa-check-circle-o"></i> Comunicar conclusão </span>
    </b-button>
</template>

<script>
import { consultoriaStatus } from '../../ConsultoriaStatus'

export default {
    props: {
        consultoria: {
            type: Object,
            default: () => ({})
        },

        services: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmar() {
            this.$swal({
                title: `Consultoria`,
                html: `Confirma a comunicação da conclusão da consultoria?
                <br/><br/><div class="alert alert-danger" role="alert">
                <div class="row">
                            <div class="col-3">
                                <i class="fa fa-exclamation-circle fa-5x"></i>
                            </div>
                            <div class="col-9">
                                <h4>Após a comunicação da conclusão a consultoria deverá ser enviada para análise</h4>
                            </div>
                        </div>
		             </div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.comunicar()
                }
            })
        },

        comunicar() {
            this.$store.dispatch('addRequest')
            let comunicacaoDto = {
                consultoriaId: this.$route.params.consultoriaId
            }
            this.services
                .comunicarConclusaoConsultoria(comunicacaoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Envio realizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterConsultoriaAtualizada')
                        } else {
                            this.$toast.error(
                                'Erro ao processar o envio para análise',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.$temAcesso('APPSE-FORN-CONS-02') &&
                this.consultoria.status === consultoriaStatus.EM_ANDAMENTO
            )
        }
    }
}
</script>
